module.exports = __webpack_public_path__ + "static/media/Bongo.7158c0db.mp3";